<template>
    <div class="collect-share-area" :style="areaStyle">
        <template v-for="(item, index) in componentlist">

            <CollectButton v-if="item.name === 'collectButton'"
                :key="index" :index="index" :info="item" :pageDetail="pageDetail" 
                :receiveData="emitData" @emitEvent="receiveEvent" />

            <ShareButton v-else-if="item.name === 'shareButton'"
                :key="index" :index="index" :info="item" :pageDetail="pageDetail"  
                :receiveData="emitData" @emitEvent="receiveEvent" />
           
        </template>
    </div>
</template>

<script>

import { CollectButton, ShareButton } from './components'

export default {

    name: 'CollectShareArea',

    components: {

        CollectButton,

        ShareButton,

    },

    props: {

        info: {
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

        pageDetail: { // 活动数据
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

        receiveData: { // 接收数据
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        }

    },

    watch: {

        receiveData: {
            handler(val) {
                this.emitData = val
            },
            deep: true
        }

    },

    data() {
        return {

            areaStyle: {},

            componentlist: [], 

            emitData: {},

        }

    },

    mounted() {

        this.init()

    },

    methods: {

        init() { // init 函数 初始化 

            this.initComponentList()

            this.dynamicStyle()

        },

        initComponentList() { // 初始化组件列表
            this.componentlist = this.info.list
        },

        dynamicStyle() { // 动态样式
            let val = this.info
            if (val && val.baseConfig) {
                let backHeight = window.screen.availWidth/(val.baseConfig.img.width/val.baseConfig.img.height)
                let height = {
                    height: `${backHeight}px`
                }
                let background = {
                    backgroundImage: `url(${val.baseConfig.img.url})`,
                    backgroundSize: `100% ${backHeight}px`,
                    backgroundPosition: '0px 0px',
                }
                this.areaStyle = {
                    ...height,
                    ...background
                }
            }
        },

        collectCardEvent(data, options) { // 点击集卡活动
            this.$emit('emitEvent', {
                type: 'collectCardEvent',
                data,
                options
            })
        },

        shareActivityEvent(data, options) { // 分享活动或卡片
            this.$emit('emitEvent', {
                type: 'shareActivityEvent',
                data,
                options
            })
        },

        receiveEvent(e) { // 接收子组件的事件
            let {
                type,
                data,
                options
            } = JSON.parse(JSON.stringify(e))
            this[type] && this[type](data, options)
        },

    },

}
</script>

<style lang="scss" scoped>

.collect-share-area {
    width: 100%;
    position: relative;

}

</style>